import { Form, Input, Row, Modal, Button } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import React from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import UserEndpoint from '../../core-module/models/LoopBack/Models/UserEndpoint';

interface Props extends FormComponentProps {
  loopBackEndpoint: UserEndpoint;
  visible: boolean;
  onCancel: () => void;
}

class ChangePasswordForm extends React.Component<Props> {
  handleOk = () => {
    let validated = false;
    this.props.form.validateFields((errors, values) => {
      validated = !errors;
    });
    if (validated) {
      this.props.loopBackEndpoint
        .changePassword(this.props.form.getFieldsValue())
        .then(() => {
          Swal({
            title: 'Wachtwoord opgeslagen',
            text: `Je wachtwoord is succesvol aangepast`,
            type: 'success',
            confirmButtonText: 'Ok'
          }).then((result) => {});
        })
        .catch(() => {
          Swal({
            title: 'Helaas',
            text: `Er is iets mis gegaan bij het opslaan van het nieuwe wachtwoord`,
            type: 'error',
            confirmButtonText: 'Ok'
          }).then((result) => {});
        });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      style: { marginTop: 20 },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    };

    return (
      <Modal
        width={'60%'}
        title={'Wachtwoord wijzigen'}
        visible={this.props.visible}
        onOk={this.handleOk}
        footer={[
          <Button
            style={{ float: 'left' }}
            key='cancel'
            htmlType={'button'}
            onClick={this.props.onCancel}
          >
            Annuleren
          </Button>,
          <Button key='save' type='primary' htmlType={'button'} onClick={this.handleOk}>
            Opslaan
          </Button>
        ]}
      >
        <Row>
          <div>
            <img
              alt='Banner'
              style={{ width: '100%' }}
              src={require('../../images/logistics-banner.jpg')}
            />
            <p
              style={{
                fontSize: '30px',
                color: 'white',
                fontWeight: 500,
                position: 'absolute',
                top: 100,
                textAlign: 'center',
                width: '100%'
              }}
            >
              Wachtwoord wijzigen
            </p>
          </div>
        </Row>
        <Form {...formItemLayout}>
          <Form.Item label={'Huidig wachtwoord'}>
            {getFieldDecorator('oldPassword', {
              rules: [{ required: true, message: 'Voer je huidige wachtwoord in' }]
            })(<Input type={'password'} />)}
          </Form.Item>
          <Form.Item label={'Nieuw wachtwoord'}>
            {getFieldDecorator('newPassword', {
              rules: [{ required: true, message: 'Voer een nieuwe wachtwoord in' }]
            })(<Input type={'password'} />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = () => ({});

export default connect<any, any, any>(null, mapStateToProps)(Form.create()(ChangePasswordForm));
